var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
    'active-step': _vm.active ,
    'done': _vm.done && !_vm.active,
  },on:{"click":function($event){return _vm.$emit('click', _vm.position)}}},[(_vm.active)?[_c('b',[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }